import { Children, cloneElement, useState } from 'react'; // took some of this from https://github.com/mzabriskie/react-draggable

function getTouchIdentifier(e) {
  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
  return null;
}

function getTouch(e, identifier) {
  if (e.targetTouches && e.targetTouches.length) {
    return findInArray(e.targetTouches, function (t) {
      return identifier === t.identifier;
    });
  } else if (e.changedTouches && e.changedTouches.length) {
    return findInArray(e.changedTouches, function (t) {
      return identifier === t.identifier;
    });
  }

  return null;
}

function findInArray(xs, f) {
  for (var i = 0; i < xs.length; i++) {
    if (f(xs[i], i, xs)) return xs[i];
  }

  return null;
}

function getClientX(e, touchIdentifier) {
  var touchObj = typeof touchIdentifier === 'number' ? getTouch(e, touchIdentifier) : null;
  if (typeof touchIdentifier === 'number' && touchObj === null) return null;
  return touchObj !== null ? touchObj.clientX : typeof e.clientX === 'number' ? e.clientX : null;
}

export default function Draggable(_ref) {
  var children = _ref.children,
      _ref$onStart = _ref.onStart,
      onStart = _ref$onStart === void 0 ? function () {} : _ref$onStart,
      _ref$onMove = _ref.onMove,
      onMove = _ref$onMove === void 0 ? function () {} : _ref$onMove,
      _ref$onEnd = _ref.onEnd,
      onEnd = _ref$onEnd === void 0 ? function () {} : _ref$onEnd;

  var _useState = useState(null),
      touchIdentifier = _useState[0],
      setTouchIdentifier = _useState[1];

  var _useState2 = useState(null),
      dragStartX = _useState2[0],
      setDragStartX = _useState2[1];

  var _useState3 = useState(false),
      isDragging = _useState3[0],
      setIsDragging = _useState3[1];

  var handleDragStart = function handleDragStart(e) {
    // Only accept left-clicks.
    if (typeof e.button === 'number' && e.button !== 0) return false; // Set touch identifier in component state if this is a touch event. This allows us to
    // distinguish between individual touches on multitouch screens by identifying which
    // touchpoint was set to this element.

    var thisTouchIdentifier = getTouchIdentifier(e);
    var clientX = getClientX(e, thisTouchIdentifier);
    if (clientX === null) return;
    setTouchIdentifier(thisTouchIdentifier);
    setDragStartX(clientX);
    setIsDragging(true);
    onStart(e, clientX);
  };

  var handleDragMove = function handleDragMove(e) {
    if (!isDragging) return;
    if (dragStartX === null) return;
    var clientX = getClientX(e, touchIdentifier);
    var offsetX = clientX - dragStartX;
    onMove(e, {
      x: clientX,
      offsetX: offsetX
    });
  };

  var handleDragEnd = function handleDragEnd(e) {
    if (!isDragging) return;
    if (dragStartX === null) return;
    var clientX = getClientX(e, touchIdentifier);
    var offsetX = clientX - dragStartX;
    setIsDragging(false);
    setDragStartX(null);
    onEnd(e, {
      x: clientX,
      offsetX: offsetX
    });
  };

  return /*#__PURE__*/cloneElement(Children.only(children), {
    onTouchStart: handleDragStart,
    onTouchEnd: handleDragEnd,
    onTouchMove: handleDragMove,
    onMouseDown: handleDragStart,
    onMouseUp: handleDragEnd,
    onMouseMove: handleDragMove,
    onMouseOut: handleDragEnd
  });
}